// import { useContext } from 'react';
// import Scrollbar from 'src/components/Scrollbar';
// import { SidebarContext } from 'src/contexts/SidebarContext';


// import {
//   Box,
//   Drawer,
//   alpha,
//   styled,
//   Divider,
//   useTheme,
//   Button,
//   lighten,
//   darken,
//   Tooltip
// } from '@mui/material';

// import SidebarMenu from './SidebarMenu';
// import Logo from 'src/components/LogoSign';

// const SidebarWrapper = styled(Box)(
//   ({ theme }) => `
     
//         color: ${theme.colors.alpha.trueWhite[70]};
//         position: relative;
//         z-index: 7;
//         height: 100%;
        
// `
// );

// function Sidebar() {
//   const { sidebarToggle, toggleSidebar } = useContext(SidebarContext);
//   const closeSidebar = () => toggleSidebar();
//   const theme = useTheme();

//   return (
//     <>
//       <SidebarWrapper
//         sx={{
//            width: sidebarToggle ? '100px' :'250px',
       
//           display: {
//             xs: 'none',
//             lg: 'inline-block'
//           },
//           position: 'fixed',
//           left: 0,
//           top: 0,
//           background:
//             theme.palette.mode === 'dark'
//               ? alpha(lighten(theme.header.background, 0.1), 0.5)
//               : darken(theme.colors.alpha.black[100], 0.5),
//           boxShadow:
//             theme.palette.mode === 'dark' ? theme.sidebar.boxShadow : 'none'
//         }}
//       >
//         <Scrollbar>
//           <Box mt={3}>
//             <Box
//               mx={2}
//               sx={{
//                 width: 52
//               }}
//             >
//              { !sidebarToggle? <Logo /> :''}
//             </Box>
//           </Box>
//      {/*    <Divider
//             sx={{
//               mt: theme.spacing(1.6),
//               mx: theme.spacing(1.5),
//               background: theme.colors.alpha.trueWhite[10]
//             }}
//           />  */}
//  <Box sx={{height:"20px"}}></Box> 
//           <SidebarMenu />
//         </Scrollbar>
//         <Divider
//           sx={{
//             background: theme.colors.alpha.trueWhite[10]
//           }}

          
//         />

//       </SidebarWrapper>
//       <Drawer
//         sx={{
//           boxShadow: `${theme.sidebar.boxShadow}`
//         }}
//         anchor={theme.direction === 'rtl' ? 'right' : 'left'}
       
//         variant="temporary"
//         elevation={9}
//       >
//         <SidebarWrapper
//           sx={{
//             background:
//               theme.palette.mode === 'dark'
//                 ? theme.colors.alpha.white[100]
//                 : darken(theme.colors.alpha.black[100], 0.5)
//           }}
//         >
//           <Scrollbar>
//             <Box mt={3}>
//               <Box
//                 mx={2}
//                 sx={{
//                   width: 52
//                 }}
//               >
//                 <Logo />
//               </Box>
//             </Box>
//             <Divider
//               sx={{
//                 mt: theme.spacing(3),
//                 mx: theme.spacing(2),
//                 background: theme.colors.alpha.trueWhite[10]
//               }}
//             />
//             <SidebarMenu />
            
//           </Scrollbar>
         
//         </SidebarWrapper>
//       </Drawer>
//     </>
//   );
// }

// export default Sidebar;


import { useContext } from 'react';
import Scrollbar from 'src/components/Scrollbar';
import { SidebarContext } from 'src/contexts/SidebarContext';
import { NavLink as RouterLink } from 'react-router-dom';

import {
  Box,
  Drawer,
  alpha,
  styled,
  Divider,
  useTheme,
  Button,
  lighten,
  darken,
  Typography
} from '@mui/material';

import SidebarMenu from './SidebarMenu';
import Logo from 'src/components/LogoSign';

const SidebarWrapper = styled(Box)(
  ({ theme }) => `
    color: ${theme.colors.alpha.trueWhite[70]};
    position: relative;
    z-index: 7;
    height: 100%;
`
);

function Sidebar() {
  const { sidebarToggle, toggleSidebar,hidesidebar } = useContext(SidebarContext);
  const closeSidebar = () => toggleSidebar();
  const theme = useTheme();

  const operatorData = JSON.parse(localStorage.getItem('operatorData') || '{}');
const regCode = operatorData?.regCode;
const accountType = localStorage.getItem('accountType');


  return (
    <>
      <SidebarWrapper
        sx={{
          width: sidebarToggle ? '100px' : '250px',
         /*  display: {
            xs: 'none', //commented this line for show in mobile
            lg: 'inline-block'
          }, */
          display: hidesidebar
  ? 'none'
  : {
      xs: 'block',
      lg: 'inline-block'
    },
          position: 'fixed',
          left: 0,
          top: 0,
          background:
            theme.palette.mode === 'dark'
              ? alpha(lighten(theme.header.background, 0.1), 0.5)
              : darken(theme.colors.alpha.black[100], 0.5),
          boxShadow:
            theme.palette.mode === 'dark' ? theme.sidebar.boxShadow : 'none'
        }}
      >
        <Scrollbar>
          <Box mt={3}>
            <Box
              mx={2}
              sx={{
                width: 52
              }}
            >
              {!sidebarToggle ? (
                <RouterLink to="/ott/dashboard" onClick={closeSidebar} style={{ textDecoration: 'none' }}>
                  <Logo />
                </RouterLink>
              ) : ''}
            </Box>
          </Box>

        {accountType !== 'OWNER' && <Box
  sx={{
    width: "100%",
    height: "50px",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    marginTop:"20px",
    //bgcolor: "#1e293b",
    borderRadius: "8px",
    textAlign: "center" // extra safety
  }}
>
  <Typography
    sx={{
      color: "#e2e8f0",
      fontSize: "15px",
      fontWeight: 500,
      letterSpacing: "0.5px",
      display: "flex",
      alignItems: "center",
      justifyContent: "center"
    }}
  >
    Reg :
    <Box
      component="span"
      sx={{
        ml: 1,
        px: 1.5,
        py: "3px",
        bgcolor: "#22c55e",
        color: "#fff",
        borderRadius: "6px",
        fontSize: "14px",
        fontWeight: 600
      }}
    >
      {regCode || "-"}
    </Box>
  </Typography>
</Box>}  
          <Box sx={{ height: '20px' }}></Box>
          <SidebarMenu />
        </Scrollbar>
        <Divider
          sx={{
            background: theme.colors.alpha.trueWhite[10]
          }}
        />
      </SidebarWrapper>
      <Drawer
        sx={{
          boxShadow: `${theme.sidebar.boxShadow}`
        }}
        anchor={theme.direction === 'rtl' ? 'right' : 'left'}
        variant="temporary"
        elevation={9}
      >
        <SidebarWrapper
          sx={{
            background:
              theme.palette.mode === 'dark'
                ? theme.colors.alpha.white[100]
                : darken(theme.colors.alpha.black[100], 0.5)
          }}
        >
          <Scrollbar>
            <Box mt={3}>
              <Box mx={2} sx={{ width: 52 }}>
              <RouterLink to="/ott/dashboard" onClick={closeSidebar} style={{ textDecoration: 'none' }}>
             <Logo />
           </RouterLink>

              </Box>
            </Box>
            <Divider
              sx={{
                mt: theme.spacing(3),
                mx: theme.spacing(2),
                background: theme.colors.alpha.trueWhite[10]
              }}
            />
            <SidebarMenu />
          </Scrollbar>
        </SidebarWrapper>
      </Drawer>
    </>
  );
}

export default Sidebar;
